import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { offices_helper } from "@/helpers/offices_helper";
import Office from "@/components/Office";
import OfficeCarousel from "@/components/OfficeCarousel";
import BackButton from "@/components/BackButton";
import SeoHead from "@/components/SeoHead";

export default function OfficePage({ filtered_offices, office }) {
  const global = getGlobal();

  return (
    <>
      <main style={{ marginTop: "120px" }}>
        <SeoHead
          page_name={`Office - ${office?.url_slug} · EarthStream`}
          canonical_link={`https://www.earthstreamglobal.com/office/${office?.url_slug}`}
        />
        <div style={{ padding: "1px 60px" }}>
          <BackButton />
        </div>
        <Office office={office} />
        <OfficeCarousel offices={filtered_offices} tag={"h2"} />
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const office = offices_helper.find(url_slug);
  const all_offices = offices_helper.fetch();

  const filtered_offices = all_offices.filter((office) => {
    return office.url_slug !== url_slug;
  });

  return {
    props: {
      filtered_offices,
      office,
    },
  };
}

export async function getStaticPaths() {
  return { paths: offices_helper.toPaths(), fallback: false };
}
